
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import NumericId from "@/vue/components/NumericId.vue";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import DatePicker from "@/vue/components/DatePicker.vue";
    import { ISaveResponse } from "@/model/ISaveResponse";
    import { IPage, Page } from "@/model/Page";

    @Component({ components: { ApiButton, NumericId, ConfirmDialogue, DatePicker } })
    export default class PageDialogue extends Vue {

        //
        // -- properties
        //

        @Ref("pageForm") private readonly pageForm!: VForm;

        shouldShowDialogue: boolean = false;

        @Prop({ required: true })
        briefingID!: string;

        @Prop({ required: true })
        page!: Page;

        get canDelete(): boolean {
            return !Utils.isEmptyId(this.page.id);
        }

        get dialogueTitle(): string {
            return Utils.isEmptyId(this.page.id) ? "Add New Page" : "Edit Page";
        }

        //
        // -- methods
        //

        // @Watch("page", { immediate: false, deep: true })
        // async onPageChanged(page: Page): Promise<void> {
        //     //console.log("PageDialogue.onPageChanged");
        //     console.log(`*** onPageChanged A: briefingID:${page.briefingID} | desc:${page.description} | isQuiz:${page.isQuiz}  | displayOrder:${page.displayOrder} `);
        //     console.log(`*** onPageChanged B: briefingID:${this.page.briefingID} | desc:${this.page.description} | isQuiz:${this.page.isQuiz}  | displayOrder:${this.page.displayOrder} `);
        // }

        async show(): Promise<void> {
            //console.log(`*** page dlg show 1: briefingID:${this.page.briefingID} | desc:${this.page.description} | isQuiz:${this.page.isQuiz}  | displayOrder:${this.page.displayOrder} `);
            this.pageForm?.resetValidation();
            this.shouldShowDialogue = true;
            //console.log(`*** page dlg show 2: briefingID:${this.page.briefingID} | desc:${this.page.description} | isQuiz:${this.page.isQuiz}  | displayOrder:${this.page.displayOrder} `);
        }

        async save(): Promise<void> {
            if (!this.pageForm.validate()) {
                toastr.warning("Please fix highlighted issues", "Cannot Save");
                return;
            }
            const response: ISaveResponse = await ApiClient.post("/api/page/save", this.page, "page-save");
            if(this.page.isNew) this.page.id = response.newID;
            toastr.success("Saved");
            this.$emit("saved", );
            this.shouldShowDialogue = false;
        }

        async cancel(): Promise<void> {
            if(this.page.isNew) {

                this.$emit("reset-page");
            }
            else {
                const data: IPage = await ApiClient.get(`/api/page/load?id=${this.page.id}`);
                this.page.update(data);
            }
            this.shouldShowDialogue = false;
        }

        confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        async doDelete(): Promise<void> {
            await ApiClient.post("/api/page/delete", this.page, "page-delete");
            toastr.warning("Deleted");
            this.$emit("reset-page");
            this.$emit("saved");
            this.shouldShowDialogue = false;
        }
    }
